import { V2, V3, } from '../../../modules/Constants';
import BillLookup from './BillLookup';
import Builder from './RefundBuilder';

const getPaidItems = (transaction) => {
  switch (transaction.version) {
    case V2:
      return () => BillLookup.getPaidOffering({
        transactionId: transaction.id,
        serviceOfferingId: transaction.serviceOfferingId,
      });
    case V3:
      return () => new Promise((resolve) => {
        resolve(
          transaction.lineItems.map(item => ({
            id: item.id,
            amount: item.amount.value,
            serviceOfferingId: item.serviceOfferingId,
          }))
        );
      });
    default:
      return () => Promise.resolve([]);
  }
};

export default {
  getPaidItems,
  Builder,
};
